import {
    HttpResponse,
    QueryModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    PartyProductQuotationModel,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse, CrudPartialUpdatePatch} from '@/libs/core/crud/crud-service';

export class PartyProductQuotationsDataService implements CrudService<PartyProductQuotationModel, PartyProductQuotationModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<PartyProductQuotationModel>): Promise<CrudListResponse<PartyProductQuotationModel>> {
        throw "NotImplemented";
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<PartyProductQuotationModel>> {
        throw "NotImplemented";
    }

    create(item: PartyProductQuotationModel, params?: RequestParams): Promise<CrudResponse<PartyProductQuotationModel>> {
        return ApiService.api.insertPartyProductQuotation(item, params);
    }

    update(item: PartyProductQuotationModel, params?: RequestParams): Promise<PartyProductQuotationModel> {
        throw "NotImplemented";
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<PartyProductQuotationModel> {
        throw "NotImplemented";
    }

    delete(query: CrudDataQuery<PartyProductQuotationModel>): Promise<CrudListResponse<PartyProductQuotationModel>> {
        throw "NotImplemented";
    }

    download(query: CrudDataQuery<PartyProductQuotationModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
